const tr = {
    num: '編號',
    creator: "製單人",
    createdAt: "製單時間",
    invStatus: '盤點狀態',
    opt: '操作',
    startInv: '我要盤點',
    validaFail: '校驗失敗',
    invalidFormat: '商品名稱與數量格式必須正確',
    operator: '操作人',
    operaTime: '操作時間',
    invRequest: '盤點申請單',
    basicInfo: '基本訊息',
    warehouseItems: '倉庫商品',
    itemList: '商品列表',
    item: '商品',
    quantity: '數量',
    enterQuantity: '請填寫入庫數量',
    cancel: '取消',
    next: '下一步',
    addFailed: '新增失敗',
    diffTip: '倉庫條碼和盤點條碼進行比對，有以下差异：',
    oneClickInOut: '一鍵出庫/入庫',
    oneClickIn: '一鍵入庫',
    oneClickOut: '一鍵出庫',
    doError: '生成差异失敗，{{err}}',
    operationTips: '當前組織正在盤點，無法進行操作。',
    createDiff: '生成差异',
    endCounting: '結束盤點',
    getDiffDataTip: '正在獲取差异數據，請稍後...',
    countingDataInventorySuccs: '盤點數據出庫/入庫成功',
    countingFinish: '盤點完成',
    countingNoData: '盤點數據不存在',
    countingCancelDiff: '當前差异數據已生成，確定取消後將結束差异。',
    dataMatchFinish: '數據匹配完畢，無差异數據！',
    diffDataTip: '盤點單存在，倉庫不存在的條碼：',
    diffDataTip2: '倉庫存在，盤點單中不存在的條碼：',
    onClickDelete: '一鍵刪除',
    seletedItems: '已選中{{num}}項',
    againAddScan: '再次添加掃描單',
    againDiff: '再次生成差异',
    countingDataIsOverTip: '該盤點單差异數據已生成，確定保留差异並且結束此次盤點嗎？',
    countingInSucc: '盤點入庫成功',
    countingOutSucc: '盤點出庫成功',
    delCountingScanBarcode: '確定刪除本次盤點掃描單中該條碼嗎?',
    barcode: '條碼',
    countingBarcodeInProduct: '盤點單中該條碼所屬商品',
    storeBarcodeInProduct: '盤點單中該條碼所屬商品',
    optDetail: '詳情',
    countingDetail: '盤點詳情',
    countingProductData: '盤點商品數據',
    overCouting: '結束盤點',
    overCoutingTip: '確定結束該盤點單嗎?',
    fillDataDoTip: '請先選擇商品和填寫條碼數據後再生成差异',
    noDataOverCounting: '當前暫無數據可結束盤點',
    diffCodes: "差異條碼",
    normalCodes: "無差異條碼",
    countingCodes: "盤點",
    confirmDelete: "確認刪除",
    confirmDeleteContent: "刪除盤點單後數據將無法恢復，確定要刪除嗎？",
    deleteSuccess: "刪除成功",
    deleteFailed: "刪除失敗",
    saveFailed: "保存失敗",
    confirmTerminate: "確認終止盤點",
    confirmTerminateContent: "終止盤點將刪除當前盤點單，確定要終止嗎？",
    terminateSuccess: "盤點單已刪除",
    terminateFailed: "終止盤點失敗",
    addSuccess: "盤點單已生成",
    itemsUpdated: "盤點單已更新",
    noCode: "存貨編碼不存在：{{code}}",
    temp: "暫存",
    tempSave: "確定暫存此盤點單？",
    tempSaveConfirm: "暫存後，你將保存當前數據。",
    batchImport: "批量導入盤點",
    downloadTemplate: "下載模版",
    importData: "導入盤點",
    invalidTemplate: "請選擇正確的模版文件",
    confirmImport: "確定導入",
    productCode: "存貨編碼",
    productName: "存貨名稱",
    productModal: "規格型號",
    productUom: "單位",
    bookNum: "帳存數量",
    countedNum: "初盤數量",
    locationIdx: "庫位",
    parseDataSuccess: "成功解析 {{count}} 條數據",
    parseDataFilter: "成功解析 {{count}} 條數據，請檢查已過濾異常數據（第 {{rows}} 行）",
    locationParseFailed: "以下庫位解析失敗: {{locations}}",
    importSuccess: "導入盤點成功",
    countingCompleted: "盤點完成",
    confirmCloseImport: "確認關閉導入",
    confirmCloseImportContent: "關閉後，已導入的數據將會丟失，確定要關閉嗎？",
    confirmDeleteRow: "確認刪除",
    confirmDeleteRowContent: "確定要刪除這條數據嗎？",
    productCodeNotExisted: "以下物料編碼不存在：「{{codes}}」",
    countingHistory: "盤點歷史",
    countingHistoryAll: "盤點歷史_全部",
    inventoryImportTemplate: "盤點導入模板",
    inputTemp: "從模版錄入",
    noLot: "不生成批次（盤點之後生成的出入庫單不生成lot）",
    initLoc: "正在準備庫位數據",
    subErr: "請輸入lot、存貨編碼、數量",
    countErr: "盤點失敗",
    countErrTip: "標紅行盤點不成功",
    countErrTip1: "如果有單號則已生成盤點單，盤點失敗，否則未生成盤點單",
    countNo: "盤點單號",
    countErrTip2: "Excel表格中有以下數據行數據異常",
    countErrTip3: "請檢查Excel表格中以下行號中的：存貨編碼、初盤數量、庫位，是否填寫正常",
    countErrTip4: "以下料號不存在",
    countErrTip5: "解析失敗",
    countErrTip6: "解析數據失敗，請檢查表格數據，稍後重試",
    countErrTip7: "第{{index}}行",
};

export default tr;